<template>
  <div id="analytics">
    <StyleAssortment />
  </div>
</template>

<script>
import StyleAssortment from '@/components/StyleAssortment';
export default {
  name: "Analytics",
  components: {
    StyleAssortment
  }
}
</script>

<style lang="scss" scoped>
  div {
    width: 500px;
    height: 500px;
  }
</style>